import React, { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSalesReportQuery } from '../../../../Store/Apis/reportApi';
import Error from '../../../../Components/Error/Error';
import Loader from '../../../../Components/Loader/Loader';
import { useOutletsQuery } from '../../../../Store/Apis/outletApi';
import { useStatusQuery } from '../../../../Store/Apis/bookingApi';
import formatDate from '../../../../Hooks/formatDate';

const PrintSalesReport = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const startDate = queryParams.get('startDate');
    const endDate = queryParams.get('endDate');
    const keyID = queryParams.get('outlet');

    const { data: Report, isSuccess, isLoading, isFetching, isError } = useSalesReportQuery({
        startDate,
        endDate,
        keyID,
      }, { skip: !startDate })


    const outletList = useOutletsQuery()
    const statusList = useStatusQuery() 
    const outlet = keyID && outletList?.data?.data.find((elem) => (elem.outletId === Number(keyID)))
    const outletName = outlet?.outletName || ''



     useEffect(() => {
            const sidebar = document.querySelector('aside.sidenav');
            const mainContent = document.querySelector('.sidenav.fixed-start + .main-content');
            const navbar = document.querySelector('.navbar-main');
          
            if (sidebar) sidebar.style.display = 'none';
            if (mainContent) mainContent.style.marginLeft = '0';
            if (navbar) navbar.style.display = 'none';
          }, []);

    useEffect(() => {
        if (isSuccess && outletList.isSuccess) {
            // Open print dialog on success
            window.print();

            // Close the page when the print dialog is closed
            const handleAfterPrint = () => {
                window.close();
            };

            window.addEventListener('afterprint', handleAfterPrint);

            return () => {
                window.removeEventListener('afterprint', handleAfterPrint);
            };
        }
    }, [isSuccess, outletList.isSuccess, window]);

    if (!isSuccess) {
        return null;
    }

    return (
        <div className='card' id="invoice">
            <div className="card-body">
                <div className="page-wrapper" style={{ padding: 0 }}>
                    {isError && <Error />}
                    {(isLoading || isFetching) && <Loader height="300px" />}
                    {(!isLoading && !isFetching) && (
                        <>
                            <table className='table table-borderless align-items-center mb-3 table-sm border-0'>
                                <tbody>
                                    <tr>
                                        <td className='px-0 border-0'>
                                            <p className='text-sm mb-0 text-dark'>Start Date</p>
                                            {formatDate(startDate)}
                                        </td>
                                        <td className='px-0 border-0'>
                                            <p className='text-sm mb-0 text-dark'>End Date</p>
                                            {formatDate(endDate)}
                                        </td>
                                        {
                                            keyID && (
                                                <td className='px-0 border-0'>
                                                    <p className='text-sm mb-0 text-dark'>Outlet</p>
                                                    {outletName}
                                                </td>
                                            )
                                        }
                                    </tr>
                                </tbody>
                            </table>

                            <div className="table-responsive mb-4">
                                <table className="table table-bordered align-items-center mb-0">
                                    <thead className="bg-light">
                                        <tr>
                                            <th style={{width: '15%'}} class="text-uppercase text-secondary text-xs opacity-7">Date</th>
                                            <th style={{width: '10%'}} class="text-uppercase text-secondary text-xs opacity-7">Order ID</th>
                                            <th style={{width: '15%'}} class="text-uppercase text-secondary text-xs  opacity-7">Customer</th>
                                            <th style={{width: '15%'}} class="text-uppercase text-secondary text-xs  opacity-7">Total</th>
                                            <th style={{width: '10%'}} class="text-uppercase text-secondary text-xs  opacity-7">Due Amount</th>
                                            <th style={{width: "10%"}} class="text-uppercase text-secondary text-xs  opacity-7">Payment Mode</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Report.data.salesDetails.length > 0 ? Report.data.salesDetails.map((sale, index) => (
                                            <tr key={index}>
                                                <td className="text-sm px-4">{formatDate(sale.date)}</td>
                                                <td className="text-sm px-4">{sale.orderNumber}</td>
                                                <td className="text-sm px-4">{sale.customer}</td>
                                                <td className="text-sm px-4">R {sale.total.toFixed(2)}</td>
                                                <td className="text-sm px-4">R {sale.dueAmount.toFixed(2)}</td>
                                                <td className="text-sm px-4">
                                                {
                                                    sale.paymentDetails.map((elem, i) => {
                                                        if(elem.paymentMode !== ''){
                                                            return <p className='mb-0 text-sm'>{elem.payAmount.toFixed(2)} <span className='text-xs'>[{elem.paymentMode}]</span></p>
                                                        }
                                                    })
                                                }
                                                </td>
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan={7} className='text-center py-5'>No Data Found !!</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="row align-items-center mb-3">
                                <div class="col-md-4">
                                    <span class="text-sm mb-0 fw-500">Total Orders:</span>
                                    <span class="text-sm text-dark ms-2 fw-600 mb-0">{Report.data.totalOrders}</span>
                                </div>
                                <div class="col-md-4">
                                    <span class="text-sm mb-0 fw-500">Total Sales:</span>
                                    <span class="text-sm text-dark ms-2 fw-600 mb-0">R {Report.data.totalSales.toFixed(2)}</span>
                                </div>
                                <div class="col-md-4">
                                    <span class="text-sm mb-0 fw-500">Total Tax Amount:</span>
                                    <span class="text-sm text-dark ms-2 fw-600 mb-0">R {Report.data.totalTaxAmount.toFixed(2)}</span>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export default PrintSalesReport;
